import { dirname, resolve } from "path";
import { fileURLToPath } from "url";

const __dirname = dirname(fileURLToPath(import.meta.url));
const platformNodeRoutingMetrics = resolve(__dirname, "../../platform/src/node-routing-metrics.ts");
const mod = await import(platformNodeRoutingMetrics);

export const recordNodeRouteMetric = mod.recordNodeRouteMetric;
export const getNodeRouteMetricsSnapshot = mod.getNodeRouteMetricsSnapshot;
export const resetNodeRouteMetricsForTests = mod.resetNodeRouteMetricsForTests;
